// extracted by mini-css-extract-plugin
module.exports = {"button":"_2a549","darkMode":"_1BiQk","loading":"_15BEO","primary":"_1gH9y","secondary":"_22F7i","tertiary":"_3wy6b","coupon":"kp2OC"};